import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import eatingIllo from "../assets/images/eating.png";
import "./EmailFormStyles.scss";

const RsvpForm = () => {
  const [formData, setFormData] = useState({
    email: "",
    attendance: "",
    guest1: {
      name: "",
      starter: "",
      main: "",
      dessert: "",
    },
    guest2: {
      name: "",
      starter: "",
      main: "",
      dessert: "",
    },
    message: "",
  });

  const starters = [
    "Melon and parma ham with rocket salad",
    "Tempura prawns with sweet chilli sauce and rocket",
    "Creamy garlic mushrooms on parsley buttered ciabatta (v/vg)",
    "No starter",
  ];
  const mains = [
    "Roast chicken with roast potatoes, veg and Yorkshire pudding",
    "Seared salmon with garlic new potatoes and asparagus in a dill sauce",
    "Baked butternut squash with couscous, feta and tenderstem broccoli (v/vg)",
    "No main",
  ];
  const desserts = [
    "Sticky toffee pudding",
    "Lemon tart with fruit compote",
    "Chocolate torte (vg)",
    "No dessert",
  ];

  const [status, setStatus] = useState("");
  const [closeSentMessage, setCloseSentMessage] = useState(false);

  useEffect(() => {
    const savedData = localStorage.getItem("saveFormData");
    if (savedData) {
      const parsed = JSON.parse(savedData);

      setFormData((prev) => ({
        ...prev,
        ...parsed,
        guest1: { ...prev.guest1, ...(parsed.guest1 || {}) },
        guest2: { ...prev.guest2, ...(parsed.guest2 || {}) },
      }));
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name.startsWith("guest1_")) {
      const field = name.replace("guest1_", "");
      setFormData((prev) => ({
        ...prev,
        guest1: {
          ...prev.guest1,
          [field]: value,
        },
      }));
    } else if (name.startsWith("guest2_")) {
      const field = name.replace("guest2_", "");
      setFormData((prev) => ({
        ...prev,
        guest2: {
          ...prev.guest2,
          [field]: value,
        },
      }));
    } else if (name.includes(".")) {
      const [guest, field] = name.split(".");
      const updated = {
        ...formData,
        [guest]: {
          ...formData[guest],
          [field]: value,
        },
      };
      setFormData(updated);
      localStorage.setItem("saveFormData", JSON.stringify(updated));
    } else {
      const updated = { ...formData, [name]: value };
      setFormData(updated);
      localStorage.setItem("saveFormData", JSON.stringify(updated));
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();

    const { email, attendance, guest1 } = formData;

    if (!email || !attendance || !formData.guest1.name) {
      setStatus("Please fill out required fields.");
      return;
    }

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      )

      .then(
        (result) => {
          console.log(result.text);
          setStatus(
            <>
              <p>
                Message sent successfully! <br />
                Thank you
              </p>
            </>,
          );
          setFormData({
            email: "",
            attendance: "",
            guest1: { name: "", starter: "", main: "", dessert: "" },
            guest2: { name: "", starter: "", main: "", dessert: "" },
            message: "",
          });
          localStorage.removeItem("saveFormData");
        },
        (error) => {
          console.log(error.text);
          setStatus("Failed to send message. Please try again.");
        },
      )
      .finally(() => {
        setCloseSentMessage(false);
      });
  };

  const isDisabled = formData.attendance === "";

  const yesFormComplete =
    formData.email &&
    formData.guest1.name &&
    formData.guest1.starter &&
    formData.guest1.main &&
    formData.guest1.dessert;

  const noFormComplete =
    formData.email && formData.guest1.name && formData.message;

  const guest1NameEntered = formData.guest1.name.trim() !== "";
  const guest2NameEntered = formData.guest2.name.trim() !== "";

  const closeMessage = () => {
    setCloseSentMessage(true);
  };

  return (
    <div className="contact-form">
      <form onSubmit={sendEmail}>
        <div className="radio-container">
          {(formData.attendance === "" || formData.attendance === "no") && (
            <p className="page-subtext">
              Please let us know if you are coming by 31st March.
            </p>
          )}

          {formData.attendance === "yes" && (
            <>
              <p className="page-subtext">
                Please let us know if you are coming, and choose your food from
                the selections below by 31st March.
              </p>
            </>
          )}

          <div className="radio-button-container main">
            <p className="radio-question margin-top">
              <b>Will you be attending?</b> <br />
              Please click yes or no. Thank you.
            </p>
            <div className="radio-button-container">
              <label className="radio-label">
                <input
                  className="radio-input"
                  type="radio"
                  name="attendance"
                  value="yes"
                  checked={formData.attendance === "yes"}
                  onChange={handleInputChange}
                  required
                />
                <span className="custom-radio"></span>
                <p className="radio-text">Yes</p>
              </label>

              <label className="radio-label">
                <input
                  className="radio-input"
                  type="radio"
                  name="attendance"
                  value="no"
                  checked={formData.attendance === "no"}
                  onChange={handleInputChange}
                  required
                />
                <span className="custom-radio"></span>
                <p className="radio-text">No</p>
              </label>
            </div>
          </div>
        </div>

        {formData.attendance === "" && null}

        {formData.attendance === "yes" && (
          <>
            <div>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                required
                disabled={isDisabled}
              />
            </div>

            <div className="div-flex ">
              <img
                src={eatingIllo}
                alt="Plate illustration"
                className="eating-illo-form"
              />
            </div>

            <p className="menu-subhead">Guest one menu choices</p>
            <div>
              <input
                type="text"
                name="guest1_name"
                placeholder="Guest one name"
                value={formData.guest1_name}
                onChange={handleInputChange}
                disabled={isDisabled}
              />
            </div>
            <p className="guest-choose">
              Guest one please choose your meal from the dropdown selections
              below.
            </p>

            <div className="select-wrapper">
              <select
                name="guest1_starter"
                value={formData.guest1.starter}
                onChange={handleInputChange}
                disabled={isDisabled || !guest1NameEntered}
              >
                <option value="">Guest one starter</option>
                {starters.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="select-wrapper">
              <select
                name="guest1_main"
                value={formData.guest1.main}
                onChange={handleInputChange}
                disabled={isDisabled || !guest1NameEntered}
              >
                <option value="">Guest one main</option>
                {mains.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="select-wrapper">
              <select
                name="guest1_dessert"
                value={formData.guest1.dessert}
                onChange={handleInputChange}
                disabled={isDisabled || !guest1NameEntered}
              >
                <option value="">Guest one dessert</option>
                {desserts.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="div-flex ">
              <img
                src={eatingIllo}
                alt="Plate illustration"
                className="eating-illo-form"
              />
            </div>

            <p className="menu-subhead">Guest two menu choices</p>

            <div>
              <input
                type="text"
                name="guest2_name"
                placeholder="Guest two name"
                value={formData.guest2_name}
                onChange={handleInputChange}
                disabled={isDisabled}
              />
            </div>
            <p className="guest-choose">
              Guest two please choose your meal from dropdown selections below.
            </p>
            <div className="select-wrapper">
              <select
                name="guest2_starter"
                value={formData.guest2.starter}
                onChange={handleInputChange}
                disabled={isDisabled || !guest2NameEntered}
              >
                <option value="">Guest two starter</option>
                {starters.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="select-wrapper">
              <select
                name="guest2_main"
                value={formData.guest2.main}
                onChange={handleInputChange}
                disabled={isDisabled || !guest2NameEntered}
              >
                <option value="">Guest two main</option>
                {mains.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="select-wrapper">
              <select
                name="guest2_dessert"
                value={formData.guest2.dessert}
                onChange={handleInputChange}
                disabled={isDisabled || !guest2NameEntered}
              >
                <option value="">Guest two dessert</option>
                {desserts.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="div-flex ">
              <img
                src={eatingIllo}
                alt="Plate illustration"
                className="eating-illo-form bottom-margin"
              />
            </div>

            <div>
              <textarea
                id="message"
                name="message"
                placeholder="Please let us know any dietary requirements or allergies"
                value={formData.message}
                onChange={handleInputChange}
                disabled={isDisabled}
              ></textarea>
            </div>
            <div className="tooltip-wrapper">
              <button type="submit" disabled={!yesFormComplete}>
                Send
              </button>

              {!yesFormComplete && (
                <span className="tooltip">
                  Please fill out email and guest one fields
                </span>
              )}
            </div>
          </>
        )}

        {formData.attendance === "no" && (
          <>
            <div>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                required
                disabled={isDisabled}
              />
            </div>
            <div>
              <input
                type="text"
                name="guest1_name"
                placeholder="Guest one name"
                value={formData.guest1.name}
                onChange={handleInputChange}
                disabled={isDisabled}
              />
            </div>
            <div>
              <input
                type="text"
                name="guest2_name"
                placeholder="Guest two name"
                value={formData.guest2.name}
                onChange={handleInputChange}
                disabled={isDisabled}
              />
            </div>
            <p className="page-text bold">
              Sorry you are not able to attend. Hope to see you soon.
            </p>
            <p className="page-text bold">
              Please send us a message in the box below.
            </p>
            <div>
              <textarea
                id="message"
                name="message"
                placeholder="Message"
                value={formData.message}
                onChange={handleInputChange}
                disabled={isDisabled}
              ></textarea>
            </div>
            <div className="tooltip-wrapper">
              <button type="submit" disabled={!noFormComplete}>
                Send
              </button>

              {!yesFormComplete && (
                <span className="tooltip">
                  Please fill out email, guest one and message fields
                </span>
              )}
            </div>
          </>
        )}
      </form>

      {status && !closeSentMessage && (
        <div className="success-message">
          <p></p>
          {status}
          <p className="close-button" onClick={closeMessage}>
            close
          </p>
        </div>
      )}
    </div>
  );
};

export default RsvpForm;
